import { useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { ExternalLink, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { getStaffKingsChatForgotPasswordUrl } from '../lib/config';

const KC_STAFF_PORTAL_PROFILE = 'https://kingschat.online/user/lwstaffportal';

export function ForgotPassword() {
  const [searchParams] = useSearchParams();
  const kcNotFound = searchParams.get('kc_not_found') === '1';

  useEffect(() => {
    document.documentElement.classList.remove('dark');
  }, []);

  const handleKingsChatVerify = () => {
    window.location.href = getStaffKingsChatForgotPasswordUrl();
  };

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-[#1558D6] via-[#2D7AFF] to-[#5B9AFF] p-4">
      <div className="w-full max-w-md bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-8">
        <div className="flex flex-col items-center mb-6">
          <div className="size-16 rounded-2xl bg-white p-2 flex items-center justify-center shadow-lg mb-4 ring-2 ring-[#1E74FD]/20">
            <img src="/favicon.png" alt="LW Staff Portal" className="size-full object-contain" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 text-center">Forgot password</h1>
          <p className="text-gray-600 text-center text-sm mt-2">
            Verify your KingsChat account. If your username matches an active staff profile, you can set a new portal password.
          </p>
        </div>

        {kcNotFound && (
          <div className="mb-6 p-4 rounded-xl border border-amber-200 bg-amber-50 text-amber-900 text-sm space-y-4">
            <p>
              This KingsChat username is not found on our records, or your staff account is not active. Follow Staff Portal on KingsChat for updates and support.
            </p>
            <Button
              type="button"
              variant="default"
              className="w-full"
              asChild
            >
              <a href={KC_STAFF_PORTAL_PROFILE} target="_blank" rel="noopener noreferrer">
                <ExternalLink className="size-4 mr-2" />
                Open Staff Portal on KingsChat
              </a>
            </Button>
          </div>
        )}

        {!kcNotFound && (
          <Button
            type="button"
            onClick={handleKingsChatVerify}
            className="w-full bg-[#1E74FD] text-white py-3 rounded-xl font-semibold hover:bg-[#1558D6] shadow-lg shadow-[#1E74FD]/30 flex items-center justify-center gap-2"
          >
            <img
              src="https://kingsch.at/h/css/images/favicon.ico"
              alt=""
              className="size-5"
            />
            Continue with KingsChat
            <ExternalLink className="size-4 opacity-80" />
          </Button>
        )}

        <div className="mt-6 text-center">
          <Link
            to="/login"
            className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-[#1E74FD]"
          >
            <ArrowLeft className="size-4" />
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}
